module.exports = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'sv', 'no'],
    localeDetection: true,
    reloadOnPrerender: process.env.NODE_ENV === 'development',
    nsSeparator: '.',
    keySeparator: false
  }
};
